// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Wo5g","selected":"Chip_selected__2NOpy"};